export interface Subscription {
  /** GUID, e.g. "0000006e-0000-0000-0000-000000000000" */
  id: string
  /** Short form used in CDN URLs and storage keys, e.g. "6e" */
  code: string
  /** Display name from the Auth0 / users API, e.g. "Muslim Hands UK" */
  name: string
}

export function toSubscriptionCode(guid: string): string {
  const first = guid.split('-')[0] ?? ''
  if (first === '') return ''
  const stripped = first.replace(/^0+/, '')
  return stripped === '' ? '0' : stripped
}

export const ACTIVE_SUB_STORAGE_KEY = 'n3o:link-builder:active-sub:v1'
